import { CustomerElement } from "../states/CustomersState/CustomerElem";
import store from "./LocalStorageAPI";
import { Customer } from "../models/Booking/Customer";
import { Department } from "../models";

/**
 * Namespace in localstorage
 */
const NAMESPACE = "twl_callcenter";

/**
 * Utility of restore interface state after page reload.
 * It will restore tabs and customers data
 */
export default class LocalStorageManager {
  public static saveCustomers(customers: CustomerElement[]) {
    let ns = store.namespace(NAMESPACE);
    let customersArray: CustomerElement[] = [];
    customers.forEach((customer) => {
      if (customer !== null) {
        customersArray.push(customer);
      }
    });
    ns.set("customers", customersArray);
  }

  public static saveTabs(tabsData: any) {
    let ns = store.namespace(NAMESPACE);

    ns.set("tabs", tabsData);
  }

  public static saveTasks(tasksData: any) {
    let ns = store.namespace(NAMESPACE);
    let result: any = {};

    for (let key in tasksData) {
      if (!tasksData.hasOwnProperty(key)) continue;

      result[tasksData[key].taskSid] = {
        taskSid: tasksData[key].taskSid,
        status: tasksData[key].status,
        attributes: {
          ...tasksData[key].attributes,
        },
      };
    }

    ns.set("tasks", result);
  }

  public static updateActiveTab(activeTabSid: string) {
    let ns = store.namespace(NAMESPACE);
    let tabsData = ns.get("tabs");

    ns.set("tabs", {
      ...tabsData,
      activeTabSid: activeTabSid,
    });
  }

  public static updateJob(tabs: any) {
    let ns = store.namespace(NAMESPACE);
    let tabsData = ns.get("tabs");

    ns.set("tabs", {
      ...tabsData,
      tabs: tabs,
    });
  }

  public static updateCustomerInTab(tabs: any) {
    let ns = store.namespace(NAMESPACE);
    let tabsData = ns.get("tabs");

    ns.set("tabs", {
      ...tabsData,
      tabs: tabs,
    });
  }

  public static getCustomersData() {
    let ns = store.namespace(NAMESPACE);
    let customersData: Customer[] = ns.get("customers");
    let customers: Customer[] = [];
    customersData.forEach((customer) => {
      if (customer.id !== undefined) {
        customers[customer.id] = customer;
      }
    });

    return customers;
  }

  public static getTabsData() {
    let ns = store.namespace(NAMESPACE);
    return ns.get("tabs");
  }

  public static getTasksData() {
    let ns = store.namespace(NAMESPACE);
    let tasksData = ns.get("tasks");
    let result: any = [];

    for (let key in tasksData) {
      if (!tasksData.hasOwnProperty(key)) continue;
      result[key] = tasksData[key];
    }

    return result;
  }

  public static hasCustomers() {
    let ns = store.namespace(NAMESPACE);
    return ns.has("customers");
  }

  public static hasTabs() {
    let ns = store.namespace(NAMESPACE);
    return ns.has("tabs");
  }

  public static hasTasks() {
    let ns = store.namespace(NAMESPACE);
    return ns.has("tasks") || [];
  }

  public static hasTabByTaskSid(sid: string) {
    let ns = store.namespace(NAMESPACE);
    let tabsData = ns.get("tabs");

    if (tabsData?.tabs) {
      for (let key in tabsData.tabs) {
        if (!tabsData.tabs.hasOwnProperty(key)) continue;
        if (tabsData.tabs[key].taskSid === sid) {
          return true;
        }
      }
    }

    return false;
  }

  public static removeTaskBySid(sid: string) {
    let ns = store.namespace(NAMESPACE);
    let tasks = ns.get("tasks");

    if (tasks && tasks[sid]) {
      delete tasks[sid];
    }

    ns.set("tasks", tasks);
  }

  /**
   * There Sender is object with data about selected phone number for sending messages
   */
  public static saveSender(sender: Department) {
    let ns = store.namespace(NAMESPACE);
    ns.set("sender", sender);
  }

  /**
   * There Sender is object with data about selected phone number for sending messages
   */
  public static getSender(): Department {
    let ns = store.namespace(NAMESPACE);
    return ns.get("sender");
  }

  public static hasSender(): boolean {
    let ns = store.namespace(NAMESPACE);
    return ns.has("sender");
  }

  public static removeSender() {
    let ns = store.namespace(NAMESPACE);
    ns.remove("sender");
  }
}
